import { render } from "./OrderDetailPage.vue?vue&type=template&id=41826a20&scoped=true&ts=true"
import script from "./OrderDetailPage.vue?vue&type=script&lang=ts"
export * from "./OrderDetailPage.vue?vue&type=script&lang=ts"

import "./OrderDetailPage.vue?vue&type=style&index=0&id=41826a20&scoped=true&lang=css"

import exportComponent from "/home/runner/work/mlp/mlp/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41826a20"]])

export default __exports__